/**
 * Common Helper will have all the common functions
 * that can be used by other apis
 */
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import RestClient from '../RestClient/RestClient';
import * as CommonConstants from './CommonConstants';
import { RestConfig, getHostConfig } from './RestConfig';
/**
 * getting device type.
 */
export const getChannel = (context) => { //eslint-disable-line
    let channel = 'desktop'; // defaults to desktop
    if (context.deviceType) {
        if (context.deviceType.isMobile) {
            channel = 'mobile';
        } else if (context.deviceType.isTablet) {
            channel = 'tablet';
        }
    }
    return channel;
};

export const getIrisMarketingSlotBanner = (params) => {
    let config = RestConfig.contentConfig();
    config.url = CommonConstants.IRIS_MARKETING_SLOT_URL;
    config.channel = params;
    config = getHostConfig(config);
    return RestClient.get(config)
        .then(/* istanbul ignore next */ (json) => json)
        .catch(
            /* istanbul ignore next */
            // Ignoring this part in coverage as error can not be simulated
            (error) => ({
                error,
            })
        );
};

export const getIrisConfiguration = () => {
    const context = RestClient.getContext();
    let config = RestConfig.contentConfig();
    config.channel = getChannel(context);
    config = getHostConfig(config);
    return config;
};

/*
 * convert cst to UTC time by tzOffset
 */
export const cstToUTCByOffset = (dateValue, tzOffset = 300) => {
    // here we get dateformat with this format 2020.02.11 11:07 which won't be supported by Safari and Firefox
    const dt = new Date(dateValue.split('.').join('/'));
    if (isNaN(dt.getTime())) {
        return null;
    }
    const YYYY = dt.getFullYear();
    const MM = dt.getMonth();
    const dd = dt.getDate();
    const HH = dt.getHours();
    const mm = dt.getMinutes();
    return new Date(Date.UTC(YYYY, MM, dd, HH, mm) + tzOffset * 60 * 1000);
};

/*
 * get the user timezone offset for zone (America/Chicago)
 * only if user sits in that zone
 */

export const getTimeOffSet = (dateValue, context) => {
    const date = new Date(dateValue);
    if (date instanceof Date && !isNaN(date.valueOf())) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 300 || timezoneOffset === 360) {
            return timezoneOffset;
        }
    }
    return context.tzOffset || 300;
};

/*
 * convert cst to UTC time
 */

export const cstToUTC = (dateValue, context) =>
    cstToUTCByOffset(dateValue, getTimeOffSet(dateValue, context));

export const extractUiContentFromCM = (responseData, supportMultiZoneData = false) => {
    const components = get(responseData, 'data.page.grid.placements', []);
    const dtmlComponents =
        (components[0] &&
            components[0].items.filter((component) => component.componentType === 'DHTML')) ||
        [];
    const firstComponent = dtmlComponents[0];
    let title = '';
    let html = '';
    try {
        if (supportMultiZoneData) {
            title = dtmlComponents.map((item) => item.name);
            html = dtmlComponents.map((item) => item.html);
        } else if (!isEmpty(firstComponent)) {
            title = firstComponent.name;
            html = firstComponent.html;
        }
    } catch (e) {
        console.log('extractUiContent error', e);
    }
    return { title, html };
};

export const extractUiContent = (responseData, supportMultiZoneData = false) => {
    const components = get(responseData, 'data.content.components', []);
    const dtmlComponents =
        components.filter((component) => component.componentType === 'dhtml') || [];
    const firstComponent = dtmlComponents[0];
    let title = '';
    let html = '';
    try {
        if (supportMultiZoneData) {
            title = dtmlComponents.map((item) => item.content.title);
            html = dtmlComponents.map((item) => item.content.html);
        } else if (!isEmpty(firstComponent)) {
            title = firstComponent.content.title;
            html = firstComponent.content.html;
        }
    } catch (e) {
        console.log('extractUiContent error', e);
    }
    return { title, html };
};
